import dayjs from "dayjs";
import mime from "mime";

export const TICKET_STATUS_MD5 = {
  pending: import.meta.env.VITE_APP_ID_STATUS_TICKET_PENDING_MD5,
  closed: import.meta.env.VITE_APP_ID_STATUS_TICKET_CLOSED_MD5,
  needInfo: import.meta.env.VITE_APP_ID_STATUS_TICKET_NEED_INFO_MD5,
  inProgress: import.meta.env.VITE_APP_ID_STATUS_TICKET_IN_PROGRESS_MD5,
};

export const TICKET_STATUS = {
  pending: import.meta.env.VITE_APP_ID_STATUS_TICKET_PENDING,
  closed: import.meta.env.VITE_APP_ID_STATUS_TICKET_CLOSED,
  needInfo: import.meta.env.VITE_APP_ID_STATUS_TICKET_NEED_INFO,
  inProgress: import.meta.env.VITE_APP_ID_STATUS_TICKET_IN_PROGRESS,
};
export const getNationalitiesAndGovernorates = (
  survey,
  nationalityList,
  FormesJuridiquesList,
  secteurData,
  gouvernoratList
) => {
  survey.getAllQuestions().forEach((question) => {
    if (question.name.toLowerCase().includes("_nationality")) {
      question.choices = nationalityList;
    }

    if (question.name === "legal_entity_legal_form") {
      question.choices = FormesJuridiquesList;
    }

    if (question.name === "training_nature_data") {
      question.panels.forEach((panel) => {
        panel.questions.forEach((question) => {
          if (question.name === "training_type_data_sector") {
            question.choices = secteurData;
          }
        });
      });
    }

    if (question.name === "trainer_data") {
      question.panels.forEach((panel) => {
        panel.questions.forEach((question) => {
          if (question.name.toLowerCase().includes("_nationality")) {
            question.choices = nationalityList;
          }
          if (question.name.toLowerCase().includes("_governorate")) {
            question.choices = gouvernoratList;
          }
        });
      });
    }

    if (question.name === "management_data") {
      question.panels.forEach((panel) => {
        panel.questions.forEach((question) => {
          if (question.name.toLowerCase().includes("_governorate")) {
            question.choices = gouvernoratList;
          }

          if (question.name.toLowerCase().includes("_nationality")) {
            question.choices = nationalityList;
          }
        });
      });
    }
    if (question.name.toLowerCase().includes("_governorate")) {
      question.choices = gouvernoratList;
    }
  });
};

export const parseDate = (dateStr) => {
  if (dayjs(dateStr, "YYYY-MM-DD", true).isValid()) {
    return dayjs(dateStr).format("YYYY-MM-DD");
  }
  if (dayjs(dateStr, "YYYY/MM/DD", true).isValid()) {
    return dayjs(dateStr, "YYYY/MM/DD").format("YYYY-MM-DD");
  }
  if (dayjs(dateStr, "DD/MM/YYYY", true).isValid()) {
    return dayjs(dateStr, "DD/MM/YYYY").format("YYYY-MM-DD");
  }
};

export const setUserData = (userData, role,survey,id_affaire) => {
  const fieldsToSet = [
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_passeport"
          : "investor_passport",
      userDataField: "passport",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_ministerial_auth_date"
          : "",
      userDataField: "date_autorisation_ministre",
    },

    {
      surveyField:
        role === "directeur"
          ? "establishment_director_date_expiration_passeport"
          : "investor_date_expiration_passeport",
      userDataField: "expiration_passeport",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_experience_years"
          : "",
      userDataField: "experience_years",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_first_name"
          : "investor_first_name_ar",
      userDataField: "prenom_ar",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_last_name"
          : "investor_last_name_ar",
      userDataField: "nom_ar",
      readOnly: true,
    },

    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_first_name_fr"
          : "investor_first_name_fr",
      userDataField: "prenom",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_last_name_fr"
          : "investor_last_name_fr",
      userDataField: "nom",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_email"
          : "investor_email",
      userDataField: "mail",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_birth_date"
          : "investor_birth_date",
      userDataField: "date_naiss_user",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_genre"
          : "investor_civility",
      userDataField: "civilite",
      readOnly: true,
    },

    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_nationality"
          : "investor_nationality",
      userDataField: "nationality",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_cin_number"
          : "investor_cin",
      userDataField: "cin",
      readOnly: true,
    },

    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_date_delivrance"
          : "investor_date_delivrance",
      userDataField: "delivrance_date",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_birth_place"
          : "investor_birth_place",
      userDataField: "birthplace",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_education_level"
          : "investor_eduction_level",
      userDataField: "niveau_scolaire",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_phone_number"
          : "investor_phone_number",
      userDataField: "telephone",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_address"
          : "investor_residence_address",
      userDataField: "adresse",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_governorate"
          : "investor_residence_governorate",
      userDataField: "goverment",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_delegation"
          : "investor_residence_delegation",
      userDataField: "delegation",
    },
    {
      surveyField:
        role === "directeur" ? "" : "investor_residence_postal_code",
      userDataField: "code_postal",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_specific_needs"
          : "investor_specific_needs",
      userDataField: "besoins_specifiques",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_cin_copie"
          : "investor_copie_cin",
      userDataField: "copie_cin",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_passeport_copie"
          : "investor_copie_passeport",
      userDataField: "copie_passeport",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_director_folder"
          : "investor_copie_cv",
      userDataField: "copie_cv",
    },
    {
      surveyField:
        role === "directeur" ? "copie_autorisation_ministre" : "",
      userDataField: "copie_autorisation_ministre",
    },
  ];


  fieldsToSet.forEach((field) => {
    const { surveyField, userDataField, readOnly } = field;
    const value =
      surveyField.includes("copie") && userData[userDataField]
        ? setFileValues(userData[userDataField])
        : surveyField.includes("_date") && userData[userDataField]
        ? parseDate(userData[userDataField])
        : userData[userDataField];
    const question = survey.getQuestionByName(surveyField);

    if (!value && !id_affaire) {
      if (question) {
        question.readOnly = false;
    }
    
    } else {
      value && survey.setValue(surveyField, value);
      if (readOnly && question) {
        question.readOnly = true;
      }
    }
  });
};


const setFileValues = (value) => {
  const fileType = mime.getType(value.name);
  const file = {
    content: value.content,
    name: value.name,
    type: fileType,
  };
  return file;
};


export const getReadOnlyQuestions = (survey,id_affaire,nationalityList ) => {
  if (id_affaire) {
    sessionStorage.setItem("consulter", true);
    survey.getAllQuestions().map((question) => {
      question.readOnly = true;
      if (
        question.name.toLowerCase().includes("reservation_number") ||
        question.name.toLowerCase().includes("tax_number")
      ) {
        question.readOnly = true;
      }
      if (question.name.toLocaleLowerCase().includes("_nationality")) {
        question.choices = nationalityList;
      }
    });

    const trainer_data = survey.getQuestionByName("trainer_data");
    trainer_data?.panels.map((panel) => {
      panel.questions.map((question) => {
        if (
          question.name === "trainer_data_cin_number" ||
          question.name === "trainer_data_passport"
        ) {
          question.readOnly = true;
        }
        if (question.name === "trainer_data_nationality") {
          question.choices = nationalityList;
        }
      });
    });

    const management_data = survey.getQuestionByName("management_data");
    management_data?.panels.map((panel) => {
      panel.questions.map((question) => {
        // if (question.name === "management_data_staff_birth_date") {
        question.readOnly = true;
        if (question.name === "management_data_staff_nationality") {
          question.choices = nationalityList;
        }
        // }
      });
    });

    survey.showCompleteButton = false;
    survey.editText = "Consulter - الإطلاع";
  } else {
    sessionStorage.setItem("consulter", false);
  }
}


export const validateStep0 = async ({ form, notification }) => {
  try {
    await form.validateFields();

    const values = form.getFieldsValue();
    const dureeEffective = parseInt(values.duree_effective);
    const nbrePeriode = parseInt(values.nbre_periode, 10);
    const duree_effective_totale = parseInt(values.duree_effective_totale);
    const duree_vacances = parseInt(values.duree_vacances);
    const duree_evaluation = parseInt(values.duree_evaluation);
    const duree_rattrapage = parseInt(values.duree_rattrapage);

    const durees_totales =
      duree_vacances + duree_evaluation + duree_rattrapage + dureeEffective;

    let totalPériodes = 0;
    for (let i = 1; i <= nbrePeriode; i++) {
      totalPériodes += parseInt(values[`nbre_semaines_periode_${i}`] || 0, 10);
    }

    if (totalPériodes !== dureeEffective) {
      notification.error({
        message: "Durée insuffisante",
        description: `La somme des périodes doit être égale à la durée effective (${dureeEffective} semaines).`,
        duration: 0,
      });
      return false;
    }

    if (durees_totales !== duree_effective_totale) {
      notification.error({
        message: "Durée insuffisante",
        description: `La somme des vacances, évaluation, rattrapage et durée effective doit être égale à la durée totale (${duree_effective_totale} semaines).`,
        duration: 0,
      });
      return false;
    }

    return true;
  } catch (err) {
    return false;
  }
};


export const validateStep1 = async ({
  modules,
  form,
  data,
  setData,
  globalData,
  notification,
  setModulesFormations,
  t,
}) => {
  try {
    await form.validateFields();

    const totalWeeks = globalData.duree_effective;

    if (modules[0]?.items?.length > 0 && totalWeeks > 0) {
      const initData = Array.from({ length: totalWeeks }, (_, i) => {
        const existingWeekData = data?.[i] || {};
        const moduleValues = modules[0].items.reduce((acc, mod) => {
          acc[mod.intitulé] = existingWeekData[mod.intitulé] || 0;
          return acc;
        }, {});
        return {
          week: i + 1,
          weeklyTotal: existingWeekData.weeklyTotal || 0,
          ...moduleValues,
        };
      });

      setData(initData);
      modules[0].items.forEach((item, index) => {
        const prefix = item.type === "Général" ? "MG" : "MS";
        item.code_module = `${prefix} ${index + 1}`;
        item.seuil_réussite = item.seuil_réussite || "sur 20";
      });

      setModulesFormations(modules);
    }

    const items = modules[0].items;
    const groupedByIntitule = items.reduce((acc, item) => {
      const key = item.intitulé[0];
      (acc[key] = acc[key] || []).push(item);
      return acc;
    }, {});

    for (const [intitule, group] of Object.entries(groupedByIntitule)) {
      if (group.length > 1) {
        notification.error({
          message: t("Erreur"),
          description: t(`Module ${intitule} en doublon`),
          duration: 0,
        });
        return false;
      }
    }

    const heuresObservation =
      Number(form.getFieldValue("duree_stage_heures_observation")) *
      Number(form.getFieldValue("duree_stage_mois_observation")) * 4;

    const heuresIntegration =
      Number(form.getFieldValue("duree_stage_heures_integration")) *
      Number(form.getFieldValue("duree_stage_mois_integration")) * 4;

    if (heuresIntegration < 160) {
      notification.error({
        message: "Stage d'intégration insuffisant",
        description: `La durée du stage d'intégration est ${heuresIntegration} h (< 160 h).`,
        duration: 0,
      });
      return false;
    }

    if (heuresObservation < 160) {
      notification.error({
        message: "Stage d'observation insuffisant",
        description: `La durée du stage d'observation est ${heuresObservation} h (< 160 h).`,
        duration: 0,
      });
      return false;
    }

    return true;
  } catch (err) {
    return false;
  }
};

export const validateStep2 = async ({
  
  form,

}) => {
  try {
    await form.validateFields();
    return true
  } catch (err) {
    return false;
  }
};



export const validateStep3 = async ({ form, isAllModulesValid }) => {
  try {
    await form.validateFields();
    return isAllModulesValid();
  } catch (err) {
    return false;
  }
};


export const validateStep4 = async ({
  form,
  globalData,
  notification,
  role,
  sessionStorage,
  setOpenModal,
  insertSpecialLines,
  data,
  plagesMultiple,
  orderedConflicts,
}) => {
  try {
    await form.validateFields();

    if (role === "rapporteur") return true;

    const sommes = { examen: 0, rattrapage: 0, vacances: 0 };

    const periodeKeys = [
      { key: "semaines_examen", field: "nbre_examen_periode", target: "examen" },
      { key: "semaines_vacances", field: "nbre_vacances_periode", target: "vacances" },
      { key: "semaines_examen", field: "nbre_rattrapage_periode", target: "rattrapage" },
    ];

    periodeKeys.forEach(({ key, field, target }) => {
      const semaines = form.getFieldValue(key);
      semaines?.[0]?.items?.forEach((item) => {
        sommes[target] += item?.[field] || 0;
      });
    });

    const validations = [
      {
        type: "examen",
        value: sommes.examen,
        limit: globalData?.duree_evaluation * 7,
        label: "la durée d'évaluation",
      },
      {
        type: "rattrapage",
        value: sommes.rattrapage,
        limit: globalData?.duree_rattrapage * 7,
        label: "la durée du rattrapage",
      },
      {
        type: "vacances",
        value: sommes.vacances,
        limit: globalData?.duree_vacances * 7,
        label: "la durée des vacances",
      },
    ];

    const error = validations.find(({ value, limit }) => value > limit);
    if (error) {
      notification.error({
        message: "Erreur",
        description: `La somme des jours ${
          error.type === "examen" ? "d'" : "de"
        }${error.type} (${error.value}) dépasse ${error.label} (${error.limit}).`,
        duration: 0,
      });
      return false;
    }

    if (
      sessionStorage.getItem("consulter") !== "true" &&
      role !== "rapporteur"
    ) {
      setOpenModal(insertSpecialLines(data, plagesMultiple, orderedConflicts));
      return false;
    }

    return true;
  } catch (err) {
    return false;
  }
};


export const validateStep5 = async ({ form, checkModulesCoverage, notification, t }) => {
  try {
    await form.validateFields();
    const missing = checkModulesCoverage();

    if (missing.length > 0) {
      notification.error({
        message: t("Erreur"),
        description: `Les modules suivants ne sont pas assignés à un profil : ${missing.join(", ")}`,
        duration: 0,
      });
      return false;
    }

    return true;
  } catch (err) {
    return false;
  }
};

export const validateStep6 = async ({ form, notification, t }) => {
  try {
    await form.validateFields();

    const values = form.getFieldsValue();
    const equipements = values.equipements || [];

    const seen = new Set();
    for (let item of equipements) {
      const designation = item.designation_equipement?.trim();
      if (designation && seen.has(designation)) {
        notification.error({
          message: t("Erreur"),
          description: t("Deux équipements ont la même désignation."),
          duration: 0,
        });
        return false;
      }
      if (designation) seen.add(designation);
    }

    return true;
  } catch (err) {
    return false;
  }
};

export const validateStep7 = async ({ form, notification, t }) => {
  try {
    await form.validateFields();

    const values = form.getFieldsValue();
    const espaces = values.espaces || [];

    const seen = new Set();
    for (let item of espaces) {
      const designation = item.designation_espaces?.trim();
      if (designation && seen.has(designation)) {
        notification.error({
          message: t("Erreur"),
          description: t("Deux espaces ont la même désignation."),
          duration: 0,
        });
        return false;
      }
      if (designation) seen.add(designation);
    }

    return true;
  } catch (err) {
    return false;
  }
};

export const validateStep8 = async ({ form, notification, t }) => {
  try {
    await form.validateFields();
    return true;
  } catch (err) {
    return false;
  }
};






